import { render, staticRenderFns } from "./AppAnnotationPart8.vue?vue&type=template&id=01dd7ef4&scoped=true"
import script from "./AppAnnotationPart8.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart8.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart8.vue?vue&type=style&index=0&id=01dd7ef4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dd7ef4",
  null
  
)

export default component.exports